
import { Component, Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { IconName } from '../icon/icons/icon-map';

export type ButtonStyle = 'default' | 'outline' | 'danger' | 'flat';
export type ButtonSize = 'small' | 'medium' | 'large';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    imports: [IconComponent]
})
export class ButtonComponent {
  @Input() id?: string;
  @Input() buttonStyle: ButtonStyle = 'default';
  @Input() size: ButtonSize = 'medium';
  @Input() icon?: IconName;
  @Input() title = '';
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';

  getButtonClasses() {
    return [
      'app-button-style',
      `app-button-style__${this.buttonStyle}`,
      `app-button-style__${this.size}`,
    ]
      .join(' ')
      .trim();
  }

  getColor() {
    if (this.buttonStyle === 'outline' || this.buttonStyle === 'flat') {
      return '#333E48';
    }
    return '#FFFFFF';
  }
}
